import { Switch } from '@headlessui/react'
import { FC } from 'react'

import { cn } from '@/app/utils'

type SwitchSize = 'md' | 'sm'

type Props = {
  disabled?: boolean
  label?: string
  checked?: boolean
  onChange?: (e: boolean) => void
  className?: string
  size?: SwitchSize
}

const TRACK_CLASS_BY_SIZE = {
  md: 'h-[32px] w-[56px]',
  sm: 'h-[20px] w-[40px]'
}

const THUMB_CLASS_BY_SIZE = {
  md: 'h-[28px] w-[28px]',
  sm: 'h-[16px] w-[16px]'
}

const THUMB_TRANSLATE_BY_SIZE = {
  md: 'translate-x-[calc(56px-28px-2px-2px)]',
  sm: 'translate-x-[calc(40px-16px-2px-2px)]'
}

const AppSwitch: FC<Props> = ({
  className,
  checked,
  label,
  onChange,
  disabled,
  size = 'md'
}) => {
  return (
    <div className="flex items-center gap-x-16">
      <Switch
        disabled={disabled}
        checked={checked}
        onChange={onChange}
        className={cn(
          checked ? 'bg-bronze-40' : 'bg-grey-20',
          'relative inline-flex shrink-0 cursor-pointer rounded-full p-2 transition-colors duration-200 ease-in-out focus:outline-none',
          disabled && 'opacity-30',
          TRACK_CLASS_BY_SIZE[size],
          className
        )}
      >
        {label && <span className="sr-only">{label}</span>}
        <span
          aria-hidden="true"
          className={cn(
            'pointer-events-none inline-block transform rounded-full bg-white ring-0 transition-all duration-200 ease-in-out',
            THUMB_CLASS_BY_SIZE[size],
            checked ? THUMB_TRANSLATE_BY_SIZE[size] : 'translate-x-0'
          )}
        />
      </Switch>
      {label && (
        <p className="font-pro text-grey-80 text-20 xs:text-18">{label}</p>
      )}
    </div>
  )
}

export default AppSwitch
